// extracted by mini-css-extract-plugin
export default {"header":"Messages-module__header__kW0UQ","departmentFilter":"Messages-module__departmentFilter__7Ig+s"};